const amountOfFinancesDataObject = {
	awaiting_approval_parents: 0,
	awaiting_payment_parents: 0,
	awaiting_approval_royalties: 0,
	awaiting_payment_royalties: 0
}

export {amountOfFinancesDataObject}